import React from 'react';
import { CreateInventoryFormPanel } from './FormLayout';
import FormFieldItem from "./FormLayout";
import Input from '../Common/InputField';
import DateInput from '../Common/DateInput';
import Select from '../Common/Select';
import OnOffSwitch from '../Common/OnOffSwitch';
import {
    asset_status_options,
    yes_no_options,
    energy_source_type_options,
    phase_options,
    hertz_options
} from './utils';
import PropTypes from 'prop-types';
import LocationDropdown from './LocationDropdown';

const Heating = ({
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    locations,
    location,
    setLocation,
    subLocation,
    setSubLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    heatingType,
    setHeatingType,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    materialType,
    setMaterialType,
    systemStatus,
    setSystemStatus,
    currentGasWeightLBS,
    setCurrentGasWeightLBS,
    currentGasWeightOZ,
    setCurrentGasWeightOZ,
    ratedCoilTemperature,
    setRatedCoilTemperature,
    chargeCapacityLBS,
    setChargeCapacityLBS,
    chargeCapacityOZ,
    setChargeCapacityOZ,
    chargeCapacityDeterminedBy,
    setChargeCapacityDeterminedBy,
    temperatureClass,
    setTemperatureClass,
    coolingCapacity,
    setCoolingCapacity,
    SEER,
    setSEER,
    EER,
    setEER,
    ESEER,
    setESEER,
    oilType,
    setOilType,
    alternateLeakDetectionMethod,
    setAlternateLeakDetectionMethod,
    leakDetectionDetails,
    setLeakDetectionDetails,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    amps,
    setAmps,
    voltage,
    setVoltage,
    hertz,
    setHertz,
    phase,
    setPhase,
    systemManager,
    setSystemManager,
    hermeticallySealed,
    setHermeticallySealed,
    energySourceType,
    setEnergySourceType,
    maxDate,
}) => {

    const heating_type_options = [
        { value: "boiler", label: "Boiler" },
        { value: "direct_fire", label: "Direct Fire" }
    ];

    const temp_class_options = [
        { value: "high", label: "High" },
        { value: "medium", label: "Medium" },
        { value: "low", label: "Low" },
        { value: "dual_temp", label: "Dual Temp" },
        { value: "other", label: "Other" }
    ];

    const oil_type_options = [
        { value: "0", label: "AB" },
        { value: "2", label: "Mineral" },
        { value: "1", label: "POE" }
    ];

    const system_status_options = [
        { value: "disposed_destroyed", label: "Disposed/Destroyed" },
        { value: "mothballed", label: "Mothballed" },
        { value: "moved", label: "Moved" },
        { value: "normal_operation", label: "Normal Operation" },
        { value: "planned_retirement", label: "Planned Retirement" },
        { value: "planned_retrofit", label: "Planned Retrofit" },
        { value: "provisional_nonoperation", label: "Privisional Non-Operation" },
        { value: "retrofitted", label: "Retrofitted" },
        { value: "seasonal_nonoperation", label: "Seasonal Non-Operation" },
        { value: "seasonal_operation", label: "Seasonal Operation" },
        { value: "shutdown_retired", label: "Shutdown/Retired" },
        { value: "sold", label: "Sold" },
        { value: "under_repair", label: "Under Repair" }
    ];

    const custom_width = alternateLeakDetectionMethod ? 6 : 12;

    return (
        <CreateInventoryFormPanel enabled={false}>
            <FormFieldItem>
                <Select
                    required
                    value={newPurchaseAquisition}
                    label="Is this a new purchase / acquisition?"
                   
                    options={yes_no_options}
                    onChange={e => setNewPurchaseAquisition(e.target.value)}
                />
            </FormFieldItem>
            <LocationDropdown
                required
                locations={locations}
                location={location}
                subLocation={subLocation}
                onChangeLocation={setLocation}
                onChangeSubLocation={setSubLocation}
               
            />
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    label="Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    error={!name}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required
                    value={assetStatus}
                    label="Asset Status"
                   
                    options={asset_status_options}
                    onChange={e => setAssetStatus(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    label="Tag Number"
                    value={tagNumber}
                    onChange={e => setTagNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    label="Serial Number"
                    value={serialNumber}
                    onChange={e => setSerialNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={heatingType}
                    label="Heating Type"
                   
                    options={heating_type_options}
                    onChange={e => setHeatingType(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    date={acquisitionDate}
                    onChange={date => setAquisitionDate(date)}
                    label="Acquisition Date *"
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    date={disbursementDate}
                    onChange={date => setDisbursementDate(date)}
                    label="Disbursement Date"
                   
                    disabled
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    date={installDate}
                    onChange={date => setInstallDate(date)}
                    label="Install Date *"
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={materialType}
                    label="Material Type"
                   
                    options={manufacturers}
                    onChange={e => setMaterialType(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={systemStatus}
                    label="Operational Status"
                   
                    options={system_status_options}
                    onChange={e => setSystemStatus(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Current Gas Weight lbs."
                    value={currentGasWeightLBS}
                    onChange={e => setCurrentGasWeightLBS(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Current Gas Weight oz."
                    value={currentGasWeightOZ}
                    onChange={e => setCurrentGasWeightOZ(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    disabled
                    fullWidth
                    label="Rated Coil Temperature (F)"
                    value={ratedCoilTemperature}
                    onChange={e => setRatedCoilTemperature(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Charge Capacity lbs."
                    value={chargeCapacityLBS}
                    onChange={e => setChargeCapacityLBS(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    type="number"
                    label="Charge Capacity oz."
                    value={chargeCapacityOZ}
                    onChange={e => setChargeCapacityOZ(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Charge Capacity Determined By"
                    value={chargeCapacityDeterminedBy}
                    onChange={e => setChargeCapacityDeterminedBy(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={temperatureClass}
                    label="Temperature Class"
                   
                    options={temp_class_options}
                    onChange={e => setTemperatureClass(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Cooling Capacity"
                    value={coolingCapacity}
                    onChange={e => setCoolingCapacity(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="SEER"
                    value={SEER}
                    onChange={e => setSEER(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    multiLine
                    label="EER"
                    value={EER}
                    onChange={e => setEER(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    multiLine
                    label="ESEER"
                    value={ESEER}
                    onChange={e => setESEER(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={oilType}
                    label="Oil Type"
                   
                    options={oil_type_options}
                    onChange={e => setOilType(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <OnOffSwitch
                    label="Has Approved Alternate Leak Detection Method?"
                    value={alternateLeakDetectionMethod}
                    onChange={() => setAlternateLeakDetectionMethod(!alternateLeakDetectionMethod)}
                    labelPlacement="start"
                />
            </FormFieldItem>
            {alternateLeakDetectionMethod && (
                <FormFieldItem>
                    <Input
                        fullWidth
                        multiLine
                        label="Approved Alternate Leak Detection Details"
                        value={leakDetectionDetails}
                        onChange={e => setLeakDetectionDetails(e.target.value)}
                       
                    />
                </FormFieldItem>
            )}
            <FormFieldItem>
                <Input
                    fullWidth
                    multiLine
                    label="Location On Site"
                    value={locationOnSite}
                    onChange={e => setLocationOnsite(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={manufacturer}
                    label="Manufacturer"
                   
                    options={manufacturers}
                    onChange={e => setManufacturer(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    date={manufactureDate}
                    onChange={date => setManufactureDate(date)}
                    label="Manufacturer Date"
                   
                    maxDate={maxDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Model Number"
                    value={modelNumber}
                    onChange={e => setModelNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={modelYear}
                    label="Model Year"
                   
                    options={years}
                    onChange={e => setModelYear(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Brand"
                    value={brand}
                    onChange={e => setBrand(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="PO Number"
                    value={poNumber}
                    onChange={e => setPONumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={lifeTime}
                    label="Expected Lifetime (years)"
                   
                    options={lifeTimeOptions}
                    onChange={e => setLifeTime(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    type="number"
                    label="Amps"
                    value={amps}
                    onChange={e => setAmps(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    type="number"
                    label="Voltage"
                    value={voltage}
                    onChange={e => setVoltage(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={hertz}
                    label="Hertz"
                   
                    options={hertz_options}
                    onChange={e => setHertz(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={phase}
                    label="Phase"
                   
                    options={phase_options}
                    onChange={e => setPhase(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={systemManager}
                    label="System Manager"
                   
                    options={phase_options}
                    onChange={e => setSystemManager(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={hermeticallySealed}
                    label="Is Hermetically Sealed"
                   
                    options={yes_no_options}
                    onChange={e => setHermeticallySealed(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={energySourceType}
                    label="Energy Source Type"
                   
                    options={energy_source_type_options}
                    onChange={e => setEnergySourceType(e.target.value)}
                />
            </FormFieldItem>
        </CreateInventoryFormPanel>
    );
};

Heating.propTypes = {
    newPurchaseAquisition: PropTypes.array.isRequired,
    setNewPurchaseAquisition: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    heating: PropTypes.string.isRequired,
    setHeatingType: PropTypes.func.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    materialType: PropTypes.string.isRequired,
    setMaterialType: PropTypes.func.isRequired,
    systemStatus: PropTypes.string.isRequired,
    currentGasWeightLBS: PropTypes.string.isRequired,
    setCurrentGasWeightLBS: PropTypes.func.isRequired,
    currentGasWeightOZ: PropTypes.string.isRequired,
    setCurrentGasWeightOZ: PropTypes.func.isRequired,
    ratedCoilTemperature: PropTypes.string.isRequired,
    setRatedCoilTemperature: PropTypes.func.isRequired,
    chargeCapacityLBS: PropTypes.string.isRequired,
    setChargeCapacityLBS: PropTypes.func.isRequired,
    chargeCapacityOZ: PropTypes.string.isRequired,
    setChargeCapacityOZ: PropTypes.func.isRequired,
    chargeCapacityDeterminedBy: PropTypes.string.isRequired,
    setChargeCapacityDeterminedBy: PropTypes.func.isRequired,
    temperatureClass: PropTypes.string.isRequired,
    setTemperatureClass: PropTypes.func.isRequired,
    coolingCapacity: PropTypes.string.isRequired,
    setCoolingCapacity: PropTypes.func.isRequired,
    SEER: PropTypes.string.isRequired,
    setSEER: PropTypes.func.isRequired,
    EER: PropTypes.string.isRequired,
    setEER: PropTypes.func.isRequired,
    ESEER: PropTypes.string.isRequired,
    setESEER: PropTypes.func.isRequired,
    oilType: PropTypes.string.isRequired,
    setOilType: PropTypes.func.isRequired,
    alternateLeakDetectionMethod: PropTypes.string.isRequired,
    setAlternateLeakDetectionMethod: PropTypes.func.isRequired,
    leakDetectionDetails: PropTypes.string.isRequired,
    setLeakDetectionDetails: PropTypes.func.isRequired,
    setSystemStatus: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    setAmps: PropTypes.func.isRequired,
    amps: PropTypes.string.isRequired,
    voltage: PropTypes.string.isRequired,
    setVoltage: PropTypes.func.isRequired,
    hertz: PropTypes.string.isRequired,
    setHertz: PropTypes.func.isRequired,
    phase: PropTypes.string.isRequired,
    setPhase: PropTypes.func.isRequired,
    systemManager: PropTypes.string.isRequired,
    setSystemManager: PropTypes.func.isRequired,
    hermeticallySealed: PropTypes.string.isRequired,
    setHermeticallySealed: PropTypes.func.isRequired,
    energySourceType: PropTypes.string.isRequired,
    setEnergySourceType: PropTypes.func.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default Heating;
